import { Component, OnInit, signal, inject, output } from "@angular/core";
import { InvitationService } from "../../services";
import {
  AuviousRtcService,
  ConversationChannelEnum,
  ConversationOriginEnum,
  ConversationTypeEnum,
  copyTextToClipboard,
  debugError,
  extractErrorMessage,
  NotificationService,
  ProtectedTicketService,
  TicketTypeEnum,
} from "../../../core-ui";
import { ConferenceMode } from "@auvious/rtc";
import { Util } from "@auvious/common";
import { Interaction } from "../../models";
import { GenericErrorHandler } from "../../services/error-handlers.service";

@Component({
  selector: "app-assistant-launcher",
  templateUrl: "./assistant-launcher.component.html",
  styleUrl: "./assistant-launcher.component.scss",
  standalone: false,
})
export class AssistantLauncherComponent implements OnInit {
  private invitationService = inject(InvitationService);
  private ticketService = inject(ProtectedTicketService);
  private rtcService = inject(AuviousRtcService);
  private notification = inject(NotificationService);
  private errorHandler = inject(GenericErrorHandler);

  readonly dismiss = output<void>();

  isLoading = signal(false);
  ticketURL = signal<string>(undefined);
  ticketId: string;

  customerName = signal("customer-name");

  ngOnInit(): void {
    this.connect();
  }

  async connect() {
    try {
      this.isLoading.set(true);

      let conference = null;
      let interaction = null;

      conference = await this.rtcService.createConference({
        mode: ConferenceMode.ROUTER,
        interactionId: Util.uuidgen(),
      });
      interaction = new Interaction(conference.name);
      interaction.setType(ConversationTypeEnum.videoCall);
      interaction.setOrigin(ConversationOriginEnum.EMBEDDED);
      interaction.setChannel(ConversationChannelEnum.aiAssistant);
      // this.interactionService.setActiveInteraction(interaction);

      // always create a new room
      // this.interactionService.setActiveInteraction(interaction);
      // this.analytics.trackInvitationSent(interaction);

      const ticketRequest = this.invitationService.prepareAIAssistantInvitation(
        TicketTypeEnum.MultiUseTicket,
        conference.name
      );

      this.ticketId = await this.ticketService.createTicket(ticketRequest);
      this.ticketURL.set(
        `${location.origin}/t/${this.ticketId}`
        // `${location.origin}/t/${this.ticketId}?name=${
        //   this.customerName() || "customer-name"
        // }`
      );

      // this.interactionService.setActiveInteraction(interaction);
      // await this.cobrowseService.join(interaction.getRoom(), this.endpointType);

      this.focusCopyBtn();
    } catch (ex) {
      this.notification.error("Error", {
        body: extractErrorMessage(ex),
      });
      debugError(ex);
      this.errorHandler.handleError(ex);
    } finally {
      this.isLoading.set(false);
    }
  }

  copy() {
    copyTextToClipboard(this.ticketURL());
    this.notification.success("Copied");
  }

  customerNameChange(name: string) {
    this.ticketURL.set(
      `${location.origin}/t/${this.ticketId}?name=${name || "customer-name"}`
    );
  }

  private focusCopyBtn() {
    requestAnimationFrame(() => {
      const copyPinElm = document.querySelector(
        "[data-tid='ai-assistant/copy-url']"
      ) as HTMLButtonElement;

      copyPinElm?.focus();
    });
  }
}
